import { NetworkError, parseEnvelope, readRequestId } from './envelope';

/**
 * The unauthenticated transport. It attaches nothing, retries nothing, and
 * knows nothing about the session — that is `client.ts`'s job. `tokens:refresh`
 * uses this module directly, which is what keeps the refresh path out of the
 * retry loop it exists to serve.
 */

/** The last `X-Request-ID` seen on any response — quoted by error surfaces. */
let lastRequestId: string | null = null;

export function getLastRequestId(): string | null {
  return lastRequestId;
}

export interface HttpRequestInit extends Omit<RequestInit, 'body'> {
  body?: unknown;
}

export async function httpRequest<T>(url: string, init: HttpRequestInit = {}): Promise<T> {
  const { body, headers, ...rest } = init;

  const requestHeaders = new Headers(headers);
  requestHeaders.set('Accept', 'application/json');
  if (body !== undefined) {
    requestHeaders.set('Content-Type', 'application/json; charset=utf-8');
  }

  let response: Response;
  try {
    response = await fetch(url, {
      // The refresh cookie is host-only and HttpOnly; it rides along because
      // of this and is never read by this bundle.
      credentials: 'include',
      ...rest,
      headers: requestHeaders,
      ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    });
  } catch (cause) {
    throw new NetworkError('تعذّر الوصول إلى الخادم.', { cause });
  }

  lastRequestId = readRequestId(response) ?? lastRequestId;

  return parseEnvelope<T>(response);
}
